
export const landing = {
  hero: {
    title: "Reduza Contratações Ruins em 73%",
    subtitle: "Tome decisões de contratação baseadas em dados com avaliações cientificamente validadas. Junte-se a mais de 10.000 equipes que melhoraram o desempenho e construíram equipes mais fortes.",
    cta: "Começar Avaliação",
    trusted: "Confiado por empresas Fortune 500",
    noCard: "Não é necessário cartão de crédito",
    fastResults: "Resultados em 10 minutos"
  },
  companies: {
    title: "Confiado por líderes da indústria mundial"
  },
  stats: {
    assessments: "50K+",
    assessmentsLabel: "Avaliações Completadas",
    reduction: "73%",
    reductionLabel: "Redução em Contratações Ruins",
    rating: "4.9",
    ratingLabel: "Avaliação dos Clientes"
  },
  customerSuccess: {
    title: "Resultados Reais de Equipes Reais",
    subtitle: "Junte-se a milhares de organizações usando nossa plataforma para construir equipes mais fortes e eficazes",
    metrics: {
      performance: {
        value: "89%",
        label: "Melhoria no Desempenho da Equipe",
        description: "Equipes relatam melhor colaboração"
      },
      professionals: {
        value: "10.000+",
        label: "Profissionais Avaliados",
        description: "Em mais de 500 empresas"
      },
      satisfaction: {
        value: "4.9/5",
        label: "Satisfação do Cliente",
        description: "Baseado em mais de 2.000 avaliações"
      },
      time: {
        value: "10 min",
        label: "Tempo Médio de Conclusão",
        description: "Insights rápidos e práticos"
      }
    }
  },
  howItWorks: {
    title: "Como Funciona",
    subtitle: "Obtenha insights práticos em 3 passos simples",
    steps: {
      assess: {
        title: "Começar Avaliação",
        description: "Complete nossas avaliações comportamentais e cognitivas cientificamente validadas em menos de 30 minutos."
      },
      results: {
        title: "Obter Resultados",
        description: "Receba perfis detalhados de personalidade, habilidades cognitivas e preferências de estilo de trabalho com gráficos visuais."
      },
      decisions: {
        title: "Tomar Decisões",
        description: "Use insights para contratação, formação de equipes, planejamento de desenvolvimento e colaboração aprimorada."
      }
    }
  },
  features: {
    title: "Por Que Escolher Nossa Plataforma?",
    subtitle: "Avaliações baseadas em ciência que entregam resultados reais"
  },
  testimonials: {
    title: "O Que Nossos Clientes Dizem",
    subtitle: "Ouça de líderes que transformaram suas equipes com nossa plataforma"
  },
  finalCta: {
    title: "Pronto para Transformar Sua Contratação?",
    subtitle: "Junte-se a mais de 10.000 equipes usando nossa plataforma para tomar melhores decisões de contratação e construir equipes mais fortes.",
    cta: "Começar Avaliação Agora",
    features: {
      noCard: "Não é necessário cartão de crédito",
      compliant: "Compatível com GDPR",
      fast: "Resultados em 10 minutos"
    }
  }
};
